import { render } from "./Contact.vue?vue&type=template&id=e4f7d842&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=e4f7d842&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1372789139/src/portfolio-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4f7d842"]])

export default __exports__